/**
 * Loan Drilldown tab layout tokens.
 *
 * Single source of truth for the drilldown's page geometry. Every tab should
 * read its container width / padding from here rather than hard-coding a
 * `maxWidth` — that's what keeps Properties, Applicants, AI Review and every
 * future tab lining up at the same gutter.
 *
 * The values are the ones the Properties + Applicants tabs already shipped with
 * (via `LoanDrilldownTabContentWrapper`), promoted to constants:
 *   maxWidth "xl" → MUI's 1536px container cap
 *   py 4.5        → 36px top/bottom
 *   px 1          → 8px side gutter (the dashboard chrome supplies the rest)
 */

/** MUI Container `maxWidth` key used by every drilldown tab. */
export const LOAN_TAB_MAX_WIDTH = "xl";

/**
 * Vertical padding of the tab container (MUI spacing units → 36px).
 * Same value as `TAB_TOKENS.space.canvasPy` in tabTokens.js, expressed in MUI
 * units for the older wrapper — if you change one, change both.
 */
export const LOAN_TAB_PY = 4.5;

/** Horizontal padding of the tab container (MUI spacing units → 8px = canvasPx). */
export const LOAN_TAB_PX = 1;

/** Gap between the header block and the tab body (MUI spacing units). */
export const LOAN_TAB_BODY_MARGIN = 4;

/** Default gap between direct children of the tab body (MUI spacing units). */
export const LOAN_TAB_BODY_GAP = 0;
